// components/ConfirmationModal.tsx
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import Button from './Button';

interface ConfirmationModalProps {
    isVisible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    heading?: string;
    isLoading?: boolean;
}

const ConfirmationModal = ({
    isVisible,
    onHide,
    onConfirm,
    heading = "Do you want to perform this action?",
    isLoading = false,
}: ConfirmationModalProps) => {
    return (
        <Transition.Root show={isVisible} as={Fragment}>
            <Dialog as="div" className="fixed z-50 inset-0 overflow-y-auto" onClose={onHide}>
                <div className="flex items-center md:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">

                            <div className='p-6'>
                                <div className="h-3/4 flex flex-col w-full mb-4">
                                    <AiOutlineWarning className="self-center mb-2" size="3rem" />
                                    <p className="text-xl font-semibold text-center">{heading}</p>
                                </div>
                                <div className="w-full  flex gap-6 justify-center">
                                    <Button
                                        disabled={isLoading}
                                        variant={'destructive'}
                                        onClick={async () => {
                                            await onConfirm();
                                            onHide();
                                        }}
                                        className="w-32 h-10 rounded-lg "
                                    >
                                        Yes
                                    </Button>
                                    <Button
                                        onClick={onHide}
                                        className="w-32 h-10 rounded-lg bg-gray-200 text-black border-none md:hover:text-black md:hover:bg-gray-200 "
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default ConfirmationModal;